import * as Analytics from "../../../services/analyticsUtag";

export const generateAnalyticsData = (dealData) => ({
  link_type: "o",
  link_name: "shopping: deal details: add to cart",
  sales_event: "cart_add",
  sales_order_discount: dealData?.save_monthly_recurring,
  page_channel: "shopping",
  page_name: "shopping: deal details",
  page_master_tab: "personal",
  sales_product_id: [dealData?.sku],
  sales_product_quantity: [1],
  sales_product_category: [dealData?.categories?.[0]?.name],
  sales_product_price: [`${dealData?.monthly_recurring}`],
});

export const getUtagViewData = () =>
  Analytics.getUtagData([
    "visitor_customer_id",
    "visitor_login_status",
    "visitor_subscription_type",
    "page_site_section_lvl_1",
    "page_site_section_lvl_2",
    "page_site_section_lvl_3",
    "page_site_section_lvl_4",
    "visitor_msisdn_hash",
    "page_name",
    "page_channel",
    "page_master_tab",
    "upgrade_eligibility_status",
    "upgrade_ineligible_reason",
    "upgrade_eligible_date",
    "upgrade_customer_type",
  ]);

export const tagContinueShopping = () => {
  Analytics.link({
    ...Analytics.getUtagData([
      "page_name",
      "page_channel",
      "page_master_tab",
      "sales_product_id",
      "sales_product_price",
      "sales_product_quantity",
      "sales_product_category",
      "visitor_login_status",
      "visitor_msisdn_hash",
      "visitor_customer_id",
      "visitor_id_hash",
      "visitor_subscription_type",
      "page_site_section_lvl_1",
      "page_site_section_lvl_2",
      "page_site_section_lvl_3",
      "page_site_section_lvl_4",
    ]),
    link_type: "o",
    link_name: "shopping: deal details: continue shopping",
  });
}

export const tagJourneyChange = () => {
  Analytics.view({
    ...getUtagViewData(),
    page_name: "shopping: upgrade: journey change",
  });
}

export const tagJourneyChangeDismiss = () => {
  Analytics.link({
    ...getUtagViewData(),
    page_tool_event: "use",
    page_tool_name: "shopping: upgrade: journey change: dismiss",
  });
}

export const tagJourneyChangeUse = (toolName) => {
  Analytics.link({
    ...getUtagViewData(),
    page_tool_event: "use",
    page_tool_name: `shopping: upgrade: journey change: ${toolName}`,
  });
}

export const tagSessionUpdate = (dealData, label, productTaggingInfo) => {
  Analytics.link({
    ...Analytics.getUtagData(),
    link_type: "o",
    link_name: `shopping: deal details: ${label}`,
    sales_event: label.replace(/ /g, "_"),
    sales_product_id: [dealData?.sku],
    sales_product_quantity: [1],
    sales_product_category: [dealData?.categories?.[0]?.name],
    sales_product_price: dealData?.monthly_recurring,
    sales_order_discount: dealData?.save_monthly_recurring,
    product_sku: productTaggingInfo.product_sku,
    product_colour: productTaggingInfo.product_colour,
    product_capacity: productTaggingInfo.product_capacity,
    product_brand: productTaggingInfo.product_brand
  });
}

export const tagViewCart = (analyticsData) => {
  Analytics.link({
    ...analyticsData,
    link_type: "o",
    link_name: "shopping: devices: deal details: view cart",
    sales_event: "view cart",
  });
}